<template>
    <section>
        <div class="section4" style="width: 100vw; display: flex; position: relative; overflow-x: hidden">
            <div style="width: 100%; display: flex; flex-direction: column; padding-top: 115px">
                <div style="display: flex; flex-direction: column; align-items: flex-start; padding: 0 20px; justify-content: space-between; margin-bottom: 65px;">
                    <p data-aos="fade-up"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 25px; font-weight: 700; color: white; text-align: center; color: #000000; text-align: left; line-height: 1.5; margin-bottom: 27px">
                        궁극적인 목표는<br>
                        학생이 꿈꾸는 것
                    </p>
                    <p data-aos="fade-up"
                        data-aos-delay="100"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 500; color: white; text-align: center; color: #5A5A5A; text-align: left; line-height: 1.8;">
                        모두의 꿈을 채울 때까지 가치 있고 성공적인 입시가 되기를
                        꿈꾸고 있습니다. 언제 어디서든 누구나 우리의 서비스로 원하는 미래를 만들어 갈 수 있도록 함께 하겠습니다.
                    </p>
                </div>
                <Swiper :options="swiperOptions" ref="mySwiper" class="swiper" style="overflow: hidden; margin: 0 auto">
                    <swiper-slide v-for="index in 5" :key="index" style="width: 85%; overflow: hidden;">
                        <div>
                            <img style="width: 100%; object-fit: contain; text-align: center;" :src="require('@/assets/images/main_v2/work'+ index + '.svg')" />
                        </div>
                    </swiper-slide>
                </swiper>
            </div>
        </div>
    </section>
</template>
<script>
import {
  Swiper,
  SwiperSlide
} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon,
        Swiper,
        SwiperSlide
    },
    data() {
        return {
            boxWidth: 41,
            swiperOptions: {
                loop: true,
                pagination: {
                el: '.swiper-pagination',
                clickable: true
                },
                centeredSlides: true,
                slidesPerView: 'auto',
                spaceBetween: 12
            },
        }
    },
    watch: {

    },
    computed: {
        scrollY() {
            return this.$store.state.scrollY
        },
        mySwiper() {
            return this.$refs.mySwiper
        },
    },
    methods: {
        handleScroll(e) {
            if(this.mySwiper.$el.getBoundingClientRect().top <= window.innerHeight) {
                if(e.deltaY > 0) {
                    if(this.boxWidth < 100) {
                        this.boxWidth++
                    }
                } else {
                    if(this.mySwiper.$el.offsetHeight < this.mySwiper.$el.getBoundingClientRect().top) {
                        if(this.boxWidth > 41) {
                            this.boxWidth--
                        }
                    }
                }
            }

        }
    },
    created() {
        document.addEventListener('wheel', this.handleScroll)
    },
    beforeDestroy() {
        document.removeEventListener('wheel', this.handleScroll)
    }, 
    
}
</script>
<style>
    @keyframes position {
        from {
            margin-top: 50px
        } to {
            margin-top: 0px
        }
    }
</style>